"use client";
import Link from "components/Link";
import { pagePadding } from "data/commonClasses";
import { fetchFromAPI } from "functions";
import { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import useStyles from "styles/Footer.Style";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";
import SessionContext from "./session/SessionContext";
import SocialMedia from "./SocialMedia";
import Text from "./Text";
import moment from "moment";
import { Icon } from "@iconify/react";

export default function Footer() {
  const classes = useStyles();
  const { t } = useTranslation();

  let isMobile = useMediaQuery({ query: "(max-width: 1280px)" });
  let {
    session: { lang },
  } = useContext(SessionContext);

  const isAr = lang === "ar";

  const [state, updateState] = useState({
    facebook: "",
    twitter: "",
    supportPhoneNumber: "",
    supportEmail: "",
    instagram: "",
  });

  function setState(nextState) {
    updateState((prevState) => ({
      ...prevState,
      ...nextState,
    }));
  }

  useEffect(() => {
    function fetchData() {
      fetchFromAPI({ api: "footer" }).then((response) => {
        let result = response.response;
        let { facebook, twitter, supportPhoneNumber, supportEmail, instagram } =
          result;
        setState({
          facebook,
          twitter,
          supportPhoneNumber,
          supportEmail,
          instagram,
        });
      });
    }
    fetchData();
  }, []);

  const footerMenu = [
    {
      title: t("contactOea"),
      link: "/syndicateOverview",
    },
    {
      title: t("financialAndMedicalTransactions"),
      link: "/financialMedicalTransactions",
    },
    {
      title: t("technicalOffice"),
      link: "/technicalOffice",
    },
    {
      title: t("arbitrationCenter"),
      link: "/arbitration",
    },
    // {
    //   link: "/contactus/trainingcenter",
    //   title: t("contactTrainingCenter"),
    // },
    {
      link: "/trainings/1",
      title: t("trainingCenter"),
    },
    {
      link: "/news",
      title: t("news"),
    },
  ];
  return (
    <div className="bg-oeaMain border-b-[16px] border-[#272E33]">
      <div
        className={twMerge(
          "w-full min-h-24 flex flex-col xl:flex-row items-center text-white",
          pagePadding
        )}
      >
        {isMobile ? (
          <div className=" grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-4 my-4">
            {footerMenu.map((footerItem, index) => {
              return (
                <div key={index} className="flex items-start">
                  <Link href={footerItem?.link} as={footerItem?.as}>
                    <a className="text-white inline-block cursor-pointer">
                      {footerItem?.title}{" "}
                    </a>
                  </Link>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            className={isAr ? classes.flexListsRight : classes.flexListsLeft}
          >
            {footerMenu.map((footerItem, index) => {
              return (
                <div key={index} className="flex flex-row items-center">
                  <Link href={footerItem.link} as={footerItem.link}>
                    <a className="text-white text-infoText inline-block cursor-pointer">
                      {footerItem.title}{" "}
                    </a>
                  </Link>
                  {index < footerMenu.length - 1 && (
                    <span className="hidden md:flex mx-3 text-white h-6 w-[1px] bg-white"></span>
                  )}
                </div>
              );
            })}
          </div>
        )}
        <SocialMedia
          className="mb-5"
          instagram={state?.instagram}
          facebook={state?.facebook}
          twitter={state?.twitter}
        />
      </div>
      <div className="pb-3 flex flex-row items-center justify-center">
        <Text
          className="mx-1"
          center
          white
          bold
          inputFontS
          text={`${t("footerCopyrights")}  ©  `}
        />
        <Text white bold text={` ${moment()?.format("YYYY")}`} />
      </div>
    </div>
  );
}
